export const reservationConversations = {
  tabs: {
    calls: "Calls",
    web: "Web",
    checkins: "Check-ins",
    charges: "Charges",
    notes: "Notes",
  },
  checkinBadge: {
    allCompleted: "All check-ins completed",
    manuallyResolved: "Final delivery completed manually by an operator",
    progress: "{done}/{total} check-ins completed",
  },
  banners: {
    limitedMode:
      "This booking isn't set up for the full flow. You can only use WhatsApp and internal notes.",
    rejectedMode:
      "The request was rejected. Only WhatsApp and internal notes remain available.",
    autoReplying: "The agent is replying automatically.",
  },
  search: {
    placeholder: "Search by name, phone or booking code...",
  },
  list: {
    emptyTitle: "No conversations yet",
    emptyText:
      "When the guest writes or you send a message, the conversation will appear here.",
    noResultsTitle: "No conversations found",
    noResultsText: "Try another name, phone or booking code.",
    aiActiveTitle: "AI Agent active",
    markAllRead: "Mark all as read",
  },
  conversation: {
    windowTimer: "Message window: {hours}h remaining",
    copyPortalCopied: "Link copied",
    copyPortalTooltip: "Copy management link",
    copiedShort: "Copied",
    copyLinkShort: "Copy link",
    dropToAttach: "Drop to attach the files",
    senderBot: "BOT / STAFF",
    senderGuest: "GUEST",
    imageAlt: "Sent image",
    locationReceived: "Location received",
    viewFile: "View file",
    notSent: "Not sent",
    sending: "Sending...",
    emptyTitle: "No messages yet",
    emptyText:
      "Start the conversation with a template or wait for the guest to write.",
  },
  mode: {
    ai: "AI",
    manual: "Manual",
    agentInactiveTooltip:
      "The AI Agent isn't active for this property. Enable it from the listing settings so it replies automatically.",
    agentInactiveChip: "AI Agent inactive",
  },
  composer: {
    predefinedTitle: "Predefined replies",
    predefinedEmpty: "No predefined replies found",
    attachFile: "Attach file",
    inputPlaceholder: "Start with / to select a predefined reply.",
    removeFile: "Remove file",
    fileFallback: "file",
  },
  calls: {
    title: "Calls for this booking",
    none: "No calls linked to this booking.",
    caller: "Caller",
    bookedFromCall: "Booked from this call",
    pause: "Pause",
    play: "Play",
    downloadMp3: "Download MP3",
    noRecording: "No recording",
  },
  ota: {
    noData: "No booking data to load OTA messages.",
  },
  checkins: {
    title: "Booking check-ins",
  },
  charges: {
    title: "Booking charges",
    noData: "No booking data to load charges.",
  },
  notes: {
    title: "Internal notes",
    noData: "No booking data to load notes.",
  },
  time: {
    today: "Today {time}",
    yesterday: "Yesterday {time}",
  },
  guestFallback: "Guest",
  webGuestFallback: "Guest",
  documentFallback: "Document",
  location: {
    openInMaps: "Open in Google Maps",
    viewCoords: "View coordinates ({lat}, {lng})",
  },
  delivery: {
    read: "Read",
    delivered: "Delivered",
    queued: "Queued",
    failed: "Failed",
    sent: "Sent",
  },
  errors: {
    genericSendFail: "This message couldn't be sent via WhatsApp.",
  },
  failureShort: {
    paymentIssue: "payment issue on the WhatsApp account",
    cannotReceive: "the number can't receive WhatsApp",
    downloadFailed: "WhatsApp couldn't download the file",
    templateMissingData: "missing template data",
    requirementsNotMet: "the message doesn't meet WhatsApp's requirements",
  },
  failureTitle: {
    noWhatsapp: "No WhatsApp",
    invalidNumber: "Invalid number",
    notSent: "Not sent",
  },
  alerts: {
    paymentIssue: "Payment issue on WhatsApp",
    whatsappUnavailable: "WhatsApp unavailable",
    qualityReduced: "Reduced number quality",
  },
  toast: {
    reactivateNoConv: "Couldn't identify the conversation to reactivate it.",
    templateSent: "Template sent successfully.",
    reactivateFail: "Couldn't send the reactivation template.",
    cannotSendWhatsappTitle: "Can't send via WhatsApp",
    invalidPhoneDetail:
      "This booking's phone ({phone}) isn't a valid number. Fix it in \"Edit booking\" to message them.",
    noPhoneDetail:
      "This booking has no phone. Add it in \"Edit booking\" to message them.",
    sendErrorTitle: "Send error",
    sendErrorDetail: "The message couldn't be sent",
    errorTitle: "Error",
    copyLinkFail: "Couldn't copy the link",
    agentInactiveTitle: "AI Agent inactive",
    agentInactiveDetail:
      "This property doesn't have the AI Agent active. Enable it from the listing settings.",
    noConvId: "Couldn't identify the conversation",
    modeChangeFail: "Couldn't change the chat mode",
    agentUnavailableTitle: "AI Agent unavailable",
  },
};
